import React, { useState } from "react";
import DashboardLayout from "./DashboardLayout";
import Subscription from "../../../components/Subscription/Subscription";
import { useSelector } from "react-redux";

const Subscripiton = () => {
  const user = useSelector((state) => state.AuthSlice.user);
  return (
    <>
      <DashboardLayout>
        <Subscription role={user?.role?.name} />
      </DashboardLayout>
    </>
  );
};

export default Subscripiton;
